'use client'

import Map from './Map'

import { useEffectiveLocalizeVersion } from '@/app/hooks/useEffectiveLocalizeVersion'
import { TVesselJourneyResponse } from '@/api/v1/resources/vesselJourney'

type TProps = {
  vessel: TVesselJourneyResponse
}

export default function MapWithEffectiveLocalize({ vessel }: TProps) {
  const localizeVersion = useEffectiveLocalizeVersion()
  return <Map vessel={vessel} localizeVersion={localizeVersion} />
}
